angular.module('rightPaneModule')
  .controller('ClassroomRosterROController', [
        '$filter',
        '$q',
        '$scope',
        '$state',
        'configuration',
        'dblProductResourcesService',
        'dblStudentLoginCardReportService',
        'settingsApi',
        'authentication',
    function (
        $filter,
        $q,
        $scope,
        $state,
        configuration,
        dblProductResourcesService,
        dblStudentLoginCardReportService,
        settingsApi,
        authentication
    ) {

    // kick of loading of templates and images so they'll be ready if button is clicked
    dblStudentLoginCardReportService.init();

    configuration.injectFeatureFlags($scope);

    var customer = authentication.getCustomer();
    $scope.ssoOnly = authentication.isSsoLoginOnly(customer);

    var initializeStudents = function() {
        var type = $state.current.name;
        var params = $state.params;

        settingsApi.getItemSettings(type, params, function(data) {
            $scope.authType = data.authentication_type;
            $scope.authTypeIsText = $scope.authType === 2;
            $scope.studentList = data.students;
            $scope.activatedStudents = _.filter($scope.studentList, function (student) {
                return student.activated;
            });
        });
    };

    var initializeData = function(e, item) {
      $scope.item = item;
      initializeStudents();
    };

    $scope.$on('itemReady', initializeData);
}]);
